<!-- 图文信息详情页：文字+图片+标题+前后链接 -->
<template>
  <div class="content-block">
    <div class="info-detail-title">
      <div class="title-info">
        <div class="title">{{ detailInfo.info.title }}</div>
        <div class="publisher">发布者 <span>{{ detailInfo.info.author }}</span></div>
        <div class="visits">阅读 <span>{{ detailInfo.info.view }}</span></div>
        <div class="date">{{ detailInfo.info.create_time }}</div>
      </div>
      <div class="title-act">
<!--        <a href="#" class="collection">收藏</a>-->
<!--        <a href="#" class="share">分享</a>-->
      </div>
    </div>
    <div class="info-detail-content" v-html="removeHtmlStyle(detailInfo.info.content)">
      <p></p>
    </div>
    <div class="info-detail-content" v-if="this.detailInfo.files&& detailInfo.files.length>0">
      <ul class="attachment-ul">
        <li class="attachment-li-title">附件：</li>
        <li class="attachment-li-name" v-for="(atta, index) in detailInfo.files">
          <a :href="atta.url" target="_blank">
            {{ index + 1 }}.&nbsp;&nbsp;{{ atta.name }}
          </a>
        </li>
      </ul>
    </div>

  </div>
</template>

<script >


export default {
  name: 'InfoPageList01',
  components: {},
  props: {
    title: {
      type: String,
      default: ''
    },
    titleLength: {
      type: String,
      default: '16'
    },
    label: {
      type: String,
      default: ''
    },
    count: {
      type: String,
      default: '3'
    },
    detailInfo: {
      type: Object,
      default: function () {
        return {info: {title: '', author: '', create_time: '', view: ''}, files: []}
      }
    }
  },
  data() {
    return {
      newsDetail: [],
    }
  },
  watch:{
    detailInfo(newVal){
      console.log('更新',newVal)
      // let content=this.replaceImageSrc(newVal.info.content,'https://www.gaoyuanyunguo.com')
      // newVal.info.desc=content;
      this.detailInfo=newVal
    }
  },
  methods: {
    replaceImageSrc(html, domain) {
      var imageRegex = /<img[^>]*src="([^"]+)"[^>]*>/g;
      var replacedHtml = html.replace(imageRegex, function (match, src) {
        var newSrc = domain + src;
        return match.replace(src, newSrc);
      });
      return replacedHtml;
    },
    removeHtmlStyle: function (html) {
      let rel = /style\s*?=\s*?([‘"])[\s\S]*?\1/g;
      let newHtml = "";
      if (html) {
        newHtml = html.replace(rel, "");
        newHtml = newHtml.replace(/(<\/?span.*?>)/g, "").replace("<p>nbsp;</p>", '');
      }
      // 清除类名
      // let relClass = /class\s*?=\s*?([‘"])[\s\S]*?\1/g;
      // let newClassHtml = "";
      // if (newHtml) {
      //   newClassHtml = newHtml.replace(relClass, "");
      // }
      return newHtml;
    },
  },
  created: function () {

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

h1,
h2 {
  font-weight: normal;
}

ul {
  display: block;
  list-style-type: none;
  padding: 0;
}

li {
  position: relative;
  margin: 0px 0px 1px 0px;
  padding: 5px 5px 5px 10px;
  font-size: 14px;
  text-align: left;

}

li a {
  display: block;
  height: 20px;
  font-size: 12px;
  line-height: 20px;
  padding: 0px 0px 0px 20px;
  background-color: #fff;
  background-size: 200px auto;
  background-repeat: no-repeat;
  background-position: 0px 0px;
}

li a:hover {
  color: var(--color6);
}

a {
  color: #42b983;
  text-decoration: none;
}

li img {
  display: block;
  float: left;
  height: 80px;
  padding-right: 5px;
}

li label {
  display: block;
  font-size: 16px;
  font-weight: 500;
  color: #282A2B;
  line-height: 30px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

li span {
  display: block;
  padding-top: 6px;
  font-size: 12px;
  color: #9FA2A6;
  line-height: 20px;
}

li .date {
  display: block;
  height: 20px;
  padding-left: 26px;
  position: absolute;
  bottom: 15px;
  font-size: 12px;
  color: #9FA2A6;
  line-height: 10px;
  background-image: url(./../../assets/clock.png);
  background-size: 15px 15px;
  background-repeat: no-repeat;
  background-position: 0px 3px;
}

.publisher span {
  color: var(--color6);
}

.visits span {
  color: var(--color6);
}
.info-detail-content h2 {
  position: relative;
  margin-top: 10px;
  font-weight: bold !important;
  font-size: 16px;
  padding-left: 12px;
  text-align: left;
}
.info-detail-content h2::before {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 4px;
  background: #FFCC1C;
  display: block;
  content: "";
  height: 100%;
}
.info-detail-content h2 a {font-size: inherit;}
</style>



// WEBPACK FOOTER //
// src/components/block/InfoDetail01.vue